import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthService} from "./auth.service";
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ProfileListService {

  private apiUrl = environment.api.url;

  token: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getProfileLists(): Observable<{ profileLists: any[] }> {
    const url = `${this.apiUrl}/user/profile/dictionaries`;

    this.authService.token().subscribe(token => {
      this.token = token;
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.token}` // Use the token here
      })
    };

    let data = {}

    return this.http.post<any>(url, data, httpOptions).pipe(
      map(response => {
        if (!response || !response.data) {
          // Log a specific error if countries data is missing
          console.error('Failed to load profile lists: No data received', response);
          throw new Error('Failed to load profile lists: No data received');
        }
        return { profileLists: response.data };
      }),
      catchError(error => {
        console.error('Error during fetching profile lists:', error);  // Log the error encountered during the API call
        return throwError(() => new Error(`Failed to load profile lists: ${error.message}`));
      })
    );
  }
}
